// extracted by mini-css-extract-plugin
export default {"box":"DisableEventBox_box__ddl7p"};